import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { SuccessLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";

const ModalSuccessCompletion = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        visible={props.show}
        closable={false}
        centered={true}
        width="398px"
        footer={null}
      >
        <div className="flex flex-col justify-center items-center gap-[9px]">
          <img src={SuccessLogo} alt="" />
          <div className="flex flex-col justify-center items-center">
            <h2 className="font-roboto text-2xl font-bold mb-[16px]">
              Thankyou For Signing Up
            </h2>
            <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
              Your Account is being verified, when verification is complete, you will be notified in 1x24 hours.
            </p>
          </div>
        </div>
        <div className="content-center w-[218px] ml-4">
        <PrimaryButton
          text={t("Yes, Understand")}
          action={() => props.action()}
          styles="w-[318px] rounded-md"
        />
        </div>
      </Modal>
    </>
  );
};
export default ModalSuccessCompletion;
